import { resetFilter as expeseReset } from "./expenseSlice"; 
import { resetFilter as auditReset } from "./auditSlice";
import { AppDispatch } from "../../Store";
import {resetDropDown as resetDropDown_EmployeeList,resetPagination as resetPagination_employeeList} from './EmployeeList_Slice'


export const resetAllFilter =()=>{
    return (dispatch: AppDispatch)=>{
    dispatch(expeseReset());     
    dispatch(auditReset());    
    dispatch(resetDropDown_EmployeeList());    
    dispatch(resetPagination_employeeList());    
    }
};